import React, { useEffect, useState, useContext, useRef } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';

import { Context } from '../Context/DataContext';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button, Form, Col, Row, Container } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom';

import { FaClipboardList, FaPencilAlt, FaTrash } from 'react-icons/fa'
import { Link } from 'react-router-dom';

const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return React.useCallback(() => updateState({}), []);
}


const AddOrder1 = () => {

    const forceUpdate = useForceUpdate();
    const location = useLocation();
    const [loading, setLoading] = useState(false)
    const { state, setCustomersGlobal, setProductsGlobal } = useContext(Context)

    const [customers, setCustomers] = useState(state.customers ? state.customers : [])
    const [cust, setCust] = useState()
    const [cust_id, setCust_id] = useState(location?.state?.cust?.cust_id ? location.state.cust.cust_id : '')
    const [products, setProd] = useState(state.products ? state.products : []);
    const [presc, setPresc] = useState({});
    const [oi_items, setOi_items] = useState([{
        p_id: '', //product id
        oi_prod: '', // product name
        oi_odos: '',
        oi_sph: '',
        oi_cyl: '',
        oi_axis: '',
        oi_prism: '',
        oi_fi: '',
        oi_ct: '',
        p_exp_days: '', // product expiry
        oi_unit_price: '', // MSRP
        oi_qty: '', // order item quantity
        oi_amount: '', // order item net price,
        oi_prom_id: '',
        oi_discount: '',
        prom_apply: false, //onlye used in interface
        prom_name: '',
        prod_prom: [], // only used in interface
        prom_discount: '',// only used interface,
        oi_prom_name: '',

    }])

    const [value, setValue] = useState(location?.state?.cust?.cust_fname ? location.state.cust.cust_fname + " " + location.state.cust.cust_lname : "");
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);
    const [suggestionArr, setSuggestionArr] = useState([])


    const history = useHistory();




    function getCustomers() {

        setLoading(true)
        var st_id;
        st_id = state.storeData.st_id

        apiRequest({ st_id: st_id }, 'viewcustomers')
            .then(data => {

                setLoading(false)
                if (data.status == 1) {
                    setCustomers(data.data)
                    setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }

    function getProducts(index) {

        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'viewprod')
            .then(data => {

                if (data.status == '1') {
                    setProd(data.data)
                    setLoading(false)
                    setProductsGlobal(data.data)
                }
                else {
                    // alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Network error')
                console.log(err)
            })
    }


    function getCustPresc(cust_id) {
        setLoading(true)
        apiRequest({ cust_id, single: true }, 'viewpresc')
            .then(data => {
                setLoading(false)
                if (data.status == '1') {
                    setPresc(data.data[0])
                    forceUpdate();
                }
                else {
                    // alert(data.error)
                    setPresc({})
                }
            })
            .catch(err => {
                setLoading(false)
                setPresc({})
                console.log(err)
                alert("Internet Error")
            })
    }

    function getProdPromotions(p_id, index) {
        setLoading(true)
        console.log('p_id' + p_id)
        apiRequest({ p_id, active: true }, 'viewPromotions')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == '1') {
                    // 
                    console.log('promotions are')
                    console.log(data)
                    let arr = oi_items;
                    arr[index].prod_prom = data.data
                    setOi_items(arr);
                    forceUpdate();
                    // setPromotions(data.data)
                }
                else {
                    // alert(data.error);
                    let arr = oi_items;
                    arr[index].prod_prom = []
                    setOi_items(arr);
                    forceUpdate();


                    // setOrderPrice('');
                    // setOrderQty('');
                    // setPromotionsApply(false);
                    // setPromotions([]);
                }
            })
            .catch(err => {
                setLoading(false)
            })
    }

    function getOrderTotal() {

        var sum = 0;
        for (let key in oi_items) {
            if (oi_items[key].oi_amount) {
                sum += parseInt(oi_items[key].oi_amount)
            }

        }
        console.log('sum = ' + sum)
        return sum

    }

    function validateOrder() {


        if (!cust_id) {
            alert('Please select customer')
            return
        }
        for (let i = 0; i < oi_items.length; i++) {
            if (oi_items[i].p_id.length < 1) return alert(`Please select product in order item ${i + 1}.`);
            if (oi_items[i].oi_odos.length < 1) return alert(`Please select product od_os in order item ${i + 1}.`);
            if (oi_items[i].oi_qty < 1) return alert(`Please enter product order quantity in order item ${i + 1}.`);

            if (oi_items[i].oi_amount.length < 1) return alert(`Please enter order net price in order item ${i + 1}.`);
        }
        addOrder()

    }

    function addOrder() {


        setLoading(true)
        var o_item = {};
        var o_itemArr = [];
        var tempOiItems
        for (let i = 0; i < oi_items.length; i++) {
            tempOiItems = oi_items[i];
            for (let key in oi_items[i]) {
                if (key == 'prom_apply' || key == 'prom_name' || key == 'prod_prom' || key == 'prom_discount') {
                }
                else {
                    o_item[key] = tempOiItems[key]
                }
            }
            o_itemArr[i] = o_item;
            o_item = {}
        }

        const reqObj = {
            st_id: state.storeData.st_id,
            cust_id: cust_id,
            o_amount: getOrderTotal(),
            o_items: o_itemArr

        }

        console.log('my final object is')
        console.log(reqObj)
        apiRequest(reqObj, 'addOrder')
            .then(data => {
                setLoading(false)
                if (data.status == '1') {
                    // alert(data.msg)
                    history.push('viewOrder', {
                        cust_id: cust_id,
                        cust_fname: cust?.cust_fname ? cust?.cust_fname : '',
                        cust_lname: cust?.cust_lname ? cust?.cust_lname : ''

                    })
                }
                else alert(data.error)
                console.log(data)
            })
    }

    function formatOrderExpiry(numOfDays) {

        var dateObj = new Date();
        var month = dateObj.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
            if (dateObj.getDate() < 10) {
                let dat = "0" + dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + month + "-" + dat;
                return date
                // props.onValueChange(date);
            }
            else {
                let dat = dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + month + "-" + dat
                return date
                // props.onValueChange(date);
            }
        }
        else {
            if (dateObj.getDate() < 10) {
                let dat = "0" + dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + month + "-" + dat
                return date
                // props.onValueChange(date);
            }
            else {
                let dat = dateObj.getDate();
                dat = parseInt(dat) + parseInt(numOfDays)
                let date = dateObj.getFullYear() + "-" + month + "-" + dat
                return date
                // props.onValueChange(date);
            }

        }
    }





    useEffect(() => {

        console.log('ocation are')
        console.log(location)
        if (!state.customers.length) {
            getCustomers()
        }
        if (!state.products.length) {
            getProducts();
        }
        if (location?.state?.cust?.cust_id) {
            getCustPresc(location.state.cust.cust_id)
        }

        // addOrder();


    }, [])

    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable({ searching: false, paging: false, info: false });
        });

    }, [])




    const ViewPresc = () => (

        <Container className="mt-4" >
            <Row>
                {/* <Col>
                    <Row className="editDetails">OD</Row>
                    <Row className="editDetails">OS</Row>
                </Col> */}
                <Col className="editDetails" ></Col>
                <Col className="editDetails" >Sph</Col>
                <Col className="editDetails" >Cyl</Col>
                <Col className="editDetails" >Axis</Col>
                <Col className="editDetails" >Prism</Col>
                <Col className="editDetails" >TSC</Col>
                <Col className="editDetails" >Dia</Col>
            </Row>

            <Row className="border-bottom border-secondary"  >
                <Col className="editDetails" style={{ fontSize: 20 }} >OD</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{presc.odsph}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{presc.odcyl}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{presc.odaxis}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{presc.odprism}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{presc.odfi}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{presc.odct}</Col>
            </Row>

            <Row className="border-bottom border-secondary mt-2 " >
                <Col className="editDetails" style={{ fontSize: 20 }} >OS</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{presc.ossph}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{presc.oscyl}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{presc.osaxis}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{presc.osprism}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{presc.osfi}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{presc.osct}</Col>
            </Row>
        </Container >



    )


    return (
        <div
            onClick={() => setSuggestionArr([])}
            id="page-top">

            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >



                            <Modal

                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>

                            {/* Page Heading */}
                            <div style={{ width: "100%", height: 65 }}>
                                <div style={{ float: "left", width: "50%" }}>
                                    <h1 className="h3 mb-2 text-gray-800">Add Order</h1>
                                    <br />
                                </div>
                            </div>
                            {/* <div>
                                <select
                                    name="cust_id"
                                    id="cust_id"
                                    className="form-control form-control-user"
                                    placeholder="No of Boxes"
                                    onChange={(v) => {
                                        var obj = v.target.value;
                                        obj = JSON.parse(obj)
                                        getCustPresc(obj.cust_id)
                                        setCust_id(obj.cust_id)
                                        setCust(obj)

                                    }}
                                >
                                    <option selected disabled>
                                        Select Customer
                                    </option>
                                    {
                                        customers.map((v) => {
                                            return (
                                                <option selected={cust_id && v.cust_id == cust_id ? true : false} value={JSON.stringify(v)}>{v.cust_fname} {v.cust_lname}</option>
                                            )

                                        })
                                    }



                                </select>
                            </div> */}

                            <div className="input__wrapper" ref={wrapperRef}>
                                <input
                                    type="text"
                                    style={{ fontFamily: 'PRe' }}
                                    placeholder={value ? value : "Search Customer"}
                                    className="form-control form-control-user"
                                    onChange={(v) => {

                                        var val = v.target.value
                                        setValue(val)
                                        console.log('val =' + val)
                                        if (!val.length) {
                                            setSuggestionArr([])
                                            // setOrders(orderArr)
                                            return
                                        }
                                        try {
                                            var search = new RegExp(val, 'i'); // prepare a regex object
                                        }
                                        catch (err) {
                                            console.log(err)
                                        }
                                        var c = [];
                                        var i = 0;
                                        for (let key in customers) {
                                            if (val.indexOf(' ') >= 0) {
                                                try {
                                                    if (search.test(customers[key].cust_fname + " " + customers[key].cust_lname)) {
                                                        c[i] = customers[i]
                                                    }
                                                }
                                                catch (err) { }

                                            }
                                            try {
                                                if (search.test(customers[key].cust_fname) || search.test(customers[key].cust_lname) || search.test(customers[key].cust_phone)) {
                                                    c[i] = customers[i]
                                                }
                                            }
                                            catch (err) { }

                                            i++;
                                        }
                                        setSuggestionArr(c)
                                        forceUpdate()
                                    }}
                                    onFocus={() => {
                                        setShowDropdown(true)
                                        setSuggestionArr(customers)
                                    }}
                                    value={value}
                                />
                                {/* {showDropdown && ( */}
                                <div className="suggestions__dropdown" >
                                    {suggestionArr?.length > 0 ? (
                                        <div style={{ position: 'fixed', zIndex: 1000, backgroundColor: 'rgba(128,128,128,1)', width: "50%", borderRadius: 5, padding: 10 }}>
                                            {suggestionArr.map((v, index) => {
                                                return (
                                                    <div style={{ marginTop: 0 }}>
                                                        <input
                                                            type="button"
                                                            style={{ width: "100%", textAlign: 'left', backgroundColor: 'rgba(128,128,128,1)', color: 'white', borderWidth: 0, fontFamily: 'PMe', fontSize: 14 }}

                                                            value={v.cust_id}
                                                            onClickCapture={() => {
                                                                // alert('asd')
                                                                // var c = orderArr.filter(item => item.cust_id == v.cust_id)
                                                                getCustPresc(v.cust_id)
                                                                setCust_id(v.cust_id)
                                                                setCust(v)

                                                                setSuggestionArr([])
                                                                setValue(v.cust_fname + " " + v.cust_lname)
                                                                forceUpdate()
                                                            }}
                                                            // key={"suggestion_" + index}
                                                            // placeholder={v.cust_fname.toString()}
                                                            value={v.cust_fname.toString() + " " + v.cust_lname + " - " + v.cust_phone}
                                                        // onClick={() => setValue(v)}
                                                        />
                                                    </div>

                                                )
                                            })}
                                        </div >
                                    ) : (
                                        null
                                        // <div className="no__suggestions">No suggestions found</div>
                                    )}
                                </div>
                                {/* )} */}
                            </div>


                            {
                                Object.keys(presc).length ?
                                    <ViewPresc />
                                    : null
                            }

                            {
                                cust_id && Object.keys(presc).length ?

                                    <div className="card shadow mb-4 mt-3">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <div style={{ float: "left", height: 30 }}>
                                                    <h1 className="h5 mb-2 text-gray-800" style={{ fontFamily: 'PMe' }} >Order Items</h1>
                                                    <br />
                                                </div>
                                                <div style={{ float: "right" }}>
                                                    <Button
                                                        onClick={() => {
                                                            $(document).ready(function () {
                                                                var counter = 2;

                                                                $('#addRow').on('click', function () {
                                                                    $("#row" + counter).show();
                                                                    counter++;
                                                                });
                                                            })
                                                        }}
                                                        // type="button" id="addRow" defaultValue="+ Add more " 
                                                        onClick={() => {
                                                            // setDataTableRows([...dataTableRows, dataTableRows + 1])
                                                            setOi_items(oi_items => [...oi_items, {
                                                                p_id: '', //product id
                                                                oi_prod: '', // product name
                                                                oi_odos: '',
                                                                oi_sph: '',
                                                                oi_cyl: '',
                                                                oi_axis: '',
                                                                oi_prism: '',
                                                                oi_fi: '',
                                                                oi_ct: '',
                                                                p_exp_days: '', // product expiry
                                                                oi_unit_price: '', // MSRP
                                                                oi_qty: '', // order item quantity
                                                                oi_amount: '', // order item net price,
                                                                prod_prom: [],

                                                            }])
                                                        }}
                                                        style={{ backgroundColor: AppColors.primary, color: 'white', borderColor: AppColors.primary, marginBottom: 10, fontFamily: 'PMe' }} >
                                                        Add More
                                                    </Button>
                                                    <br />
                                                </div>
                                                <div style={{ clear: "both" }} />
                                                {/*<table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0">*/}
                                                <table
                                                    className="table table-striped table-bordered dt-responsive"
                                                    id="dataTable"
                                                    style={{ width: "100%", borderBottomColor: '#f3f3f3' }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th className="tRow">Product</th>
                                                            <th className="tRow">Promotion</th>
                                                            <th className="tRow">OD/OS</th>
                                                            {/* <th className="tRow" style={{}}>SPH</th>
                                                    <th className="tRow">CYL</th>
                                                    <th className="tRow">AXIS</th>
                                                    <th className="tRow">BC</th>
                                                    <th className="tRow">DIA</th>
                                                    <th className="tRow">PKTS</th> */}
                                                            <th className="tRow">MSRP</th>
                                                            <th className="tRow">QTY</th>
                                                            <th className="tRow">Price</th>
                                                            <th className="tRow">Discount</th>
                                                            <th className="tRow">Net Price</th>
                                                            {
                                                                oi_items.length > 1 ?
                                                                    <th className="tRow">Action</th>
                                                                    : null
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* {
                                                Object.keys(oi_items).map(function (keyName, i) {
                                                    return <DataTableRowsView item={i} />
                                                })
                                            } */}

                                                        {
                                                            oi_items.map((item, index) => {
                                                                return (
                                                                    <tr>
                                                                        <td>
                                                                            <select
                                                                                name="product[]"
                                                                                className="form-control form-control-user cbo_product"
                                                                                placeholder="Select product"
                                                                                value={oi_items.oi_prod}
                                                                                style={{ padding: "0px 0px 0px 5px" }}
                                                                                onChange={(v) => {
                                                                                    let obj = v.target.value
                                                                                    obj = JSON.parse(obj)
                                                                                    getProdPromotions(obj.p_id, index);
                                                                                    let arr = oi_items;
                                                                                    arr[index].p_id = obj.p_id
                                                                                    arr[index].oi_qty = 0
                                                                                    arr[index].oi_unit_price = obj.p_MSRP
                                                                                    arr[index].oi_prod = obj.p_name;
                                                                                    // console.log('v = ')
                                                                                    // console.log(obj)
                                                                                    arr[index].p_exp_days = obj.exp_no_days
                                                                                    arr[index].prom_apply = false;
                                                                                    // formatOrderExpiry(obj.p_age)
                                                                                    setOi_items(arr);
                                                                                    forceUpdate();
                                                                                }}

                                                                            >
                                                                                <option value selected disabled>
                                                                                    Select product
                                                                                </option>
                                                                                {
                                                                                    products.map((v) => {
                                                                                        return (
                                                                                            <option value={JSON.stringify(v)}>{v.p_name}</option>
                                                                                        )
                                                                                    })
                                                                                }

                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select
                                                                                name="cust_id"
                                                                                id="cust_id"
                                                                                className="form-control form-control-user"
                                                                                value={oi_items.prom_name}
                                                                                onChange={(v) => {
                                                                                    if (v.target.value == 'N/A') {
                                                                                        // setPromotionsApply(false);
                                                                                        let arr = oi_items;
                                                                                        arr[index].oi_prom_id = '';
                                                                                        arr[index].oi_prom_name = '';

                                                                                        arr[index].oi_qty = '';
                                                                                        arr[index].oi_amount = '';
                                                                                        arr[index].prom_discount = '';
                                                                                        arr[index].oi_discount = '';
                                                                                        arr[index].prom_apply = false;
                                                                                        setOi_items(arr)
                                                                                        forceUpdate();
                                                                                    }
                                                                                    else {
                                                                                        let obj = v.target.value
                                                                                        let arr = oi_items;
                                                                                        obj = JSON.parse(obj);
                                                                                        var makeDiscountString;
                                                                                        if (obj.prom_type == 'fixed') {
                                                                                            makeDiscountString = "$" + obj.prom_amount;
                                                                                            arr[index].oi_discount = obj.prom_amount;
                                                                                        }
                                                                                        else {
                                                                                            makeDiscountString = obj.prom_amount + "%"
                                                                                            let ar = (parseInt(item.oi_unit_price) * parseInt(obj.prom_qty)) - parseInt(obj.prom_price);
                                                                                            arr[index].oi_discount = ar.toString();
                                                                                        }


                                                                                        arr[index].oi_prom_id = obj.prom_id;
                                                                                        arr[index].oi_prom_name = obj.prom_name;
                                                                                        arr[index].prom_name = obj.prom_name
                                                                                        arr[index].oi_qty = obj.prom_qty
                                                                                        arr[index].oi_amount = obj.prom_price
                                                                                        arr[index].prom_discount = makeDiscountString

                                                                                        arr[index].prom_apply = true
                                                                                        setOi_items(arr)
                                                                                        forceUpdate();
                                                                                        // setPromotionsApply(true)
                                                                                        // setOrderQty(obj.prom_qty);
                                                                                        // setOrderPrice(obj.oi_amount);
                                                                                        // setPromDiscount(makeDiscountString);
                                                                                    }

                                                                                }}
                                                                            >
                                                                                <option value={'N/A'} >
                                                                                    N/A
                                                                                </option>
                                                                                {
                                                                                    oi_items[index].prod_prom.map((v, i) => {
                                                                                        return (
                                                                                            <option value={JSON.stringify(v)}>{v.prom_name}</option>
                                                                                        )

                                                                                    })
                                                                                }

                                                                            </select>

                                                                        </td>
                                                                        <td>
                                                                            <select
                                                                                className="form-control"
                                                                                placeholder="OD/OS"
                                                                                disabled={cust_id ? false : true}
                                                                                style={{ padding: "0px 0px 0px 5px" }}
                                                                                onChange={(v) => {
                                                                                    let arr = oi_items;
                                                                                    var val = v.target.value;
                                                                                    arr[index].oi_odos = val
                                                                                    if (presc) {
                                                                                        const sph = val + 'sph';
                                                                                        const cyl = val + 'cyl';
                                                                                        const axis = val + 'axis';
                                                                                        const prism = val + 'prism';
                                                                                        const fi = val + 'fi';
                                                                                        const ct = val + 'ct';
                                                                                        arr[index].oi_sph = presc[sph]
                                                                                        arr[index].oi_cyl = presc[cyl]
                                                                                        arr[index].oi_axis = presc[axis]
                                                                                        arr[index].oi_prism = presc[prism]
                                                                                        arr[index].oi_fi = presc[fi]
                                                                                        arr[index].oi_ct = presc[ct]

                                                                                    }
                                                                                    setOi_items(arr)
                                                                                    forceUpdate();
                                                                                }}
                                                                            >
                                                                                <option selected disabled={true}>Select</option>
                                                                                <option value="od">OD</option>
                                                                                <option value="os">OS</option>
                                                                            </select>
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                className="cbo_quantity form-control form-control-user"
                                                                                disabled={true}
                                                                                placeholder={item.oi_unit_price}
                                                                                value={item.oi_unit_price}
                                                                                style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                            ></input>
                                                                            <br />

                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className="cbo_quantity form-control form-control-user"
                                                                                disabled={item.prom_apply || !item.oi_prod && true}
                                                                                placeholder={item.oi_qty ? item.oi_qty : "0"}
                                                                                value={item.oi_qty}
                                                                                onChange={(v) => {
                                                                                    let arr = oi_items;
                                                                                    arr[index].oi_qty = v.target.value;
                                                                                    arr[index].oi_amount = v.target.value * item.oi_unit_price;
                                                                                    setOi_items(arr);
                                                                                    forceUpdate();
                                                                                }}
                                                                                style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                            ></input>
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className="cbo_quantity form-control form-control-user"
                                                                                disabled={true}
                                                                                value={item.oi_unit_price * item.oi_qty}
                                                                                style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                            ></input>
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className="cbo_quantity form-control form-control-user"
                                                                                style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                                disabled={true}
                                                                                value={item.prom_discount}
                                                                                placeholder={item.prom_discount ? item.prom_discount : "0"}
                                                                            ></input>
                                                                        </td>
                                                                        <td >
                                                                            <input
                                                                                className="cbo_quantity form-control form-control-user"
                                                                                disabled={item.prom_apply}
                                                                                placeholder={item.oi_amount ? item.oi_amount : "0"}
                                                                                value={item.oi_amount}
                                                                                onChange={(v) => {
                                                                                    let arr = oi_items;
                                                                                    arr[index].oi_amount = v.target.value
                                                                                    setOi_items(arr)
                                                                                    forceUpdate();
                                                                                }}
                                                                                style={{ width: 50, padding: "0px 0px 0px 5px" }}
                                                                            ></input>
                                                                        </td>
                                                                        {
                                                                            index > 0 && index == oi_items.length - 1 ?

                                                                                <td>
                                                                                    <Button
                                                                                        onClick={() => {

                                                                                            let arr = oi_items;
                                                                                            arr.splice(index, 1);
                                                                                            setOi_items(arr);
                                                                                            forceUpdate()
                                                                                        }}
                                                                                        className="btn btn-danger">
                                                                                        <FaTrash color="white" />
                                                                                    </Button>

                                                                                </td>
                                                                                : null
                                                                        }




                                                                    </tr>
                                                                )
                                                            })
                                                        }


                                                    </tbody>
                                                </table>
                                                <div className="row mt-4" style={{ textAlign: 'right', marginRight: 50 }} >
                                                    <h4 className="h5 mb-2 text-gray-800" style={{ fontFamily: 'PMe' }} >Order Total: {getOrderTotal()}</h4>

                                                </div>
                                                <div style={{ textAlign: "center" }}>
                                                    <button
                                                        onClick={() => validateOrder()}
                                                        className="btn" style={{ backgroundColor: AppColors.primary, color: 'white', fontFamily: 'RBo' }} >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                cust_id && !Object.keys(presc).length && !loading ?
                                    <div>

                                        <Link
                                            className="btn btn-primary btn-user btn-block rBBtn"
                                            style={{ color: 'white', textDecorationLine: 'none', backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo', marginTop: 50 }}
                                            to={{
                                                pathname: "/addPresciption",
                                                state: cust
                                            }}
                                        >
                                            Add Prescription
                                        </Link>
                                    </div>

                                    : null
                            }
                        </div>
                        {/* /.container-fluid */}
                        {/* End of Main Content */}
                        {/* End of Content Wrapper */}
                        {/* End of Page Wrapper */}
                        {/* Scroll to Top Button*/}
                        <a className="scroll-to-top rounded" href="#page-top">
                            <i className="fas fa-angle-up" />
                        </a>
                        {/* Logout Modal*/}
                      
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AddOrder1



 // "o_items": [
            //     {
            //         "p_id": "6",
            //         "oi_prod": "test product02",
            //         "oi_odos": "od",
            //         "oi_sph": "test1",
            //         "oi_cyl": "1",
            //         "oi_axis": "1",
            //         "oi_prism": "0",
            //         "oi_fi": "0",
            //         "oi_ct": "0",
            //         "p_exp_days": "2021/11/29",
            //         "oi_unit_price": "1251",
            //         "oi_qty": "2",
            //         "oi_amount": "2440"
            //     }
            // ]